export enum OIDC_ROUTE_NAMES {
  OAUTH_CODE = "oauth-code",
}
